import { apiGet } from "../../API/Service/apiClient";

export const handleGetHomeProduct_list = async ({  
  setBrandLoading,
  setProducts,
  }) => {
  // setLoading(true);
  try {
    const resData = await apiGet("sub-product", {action:'tree'});    
    setProducts(resData?.data)
  } catch (error) {
    // console.log("Something went wrong! Please try again", "danger");
  } finally {
    setBrandLoading(false);
  }
};